import { Directive, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appNgInit]',
    exportAs: 'appNgInit'
})
export class NgInitDirective implements OnInit {
    @Input() appNgInit: () => any;

    constructor() { }

    ngOnInit() {
        if (typeof this.appNgInit === 'function') {
            this.appNgInit();
        }
    }
}
